const getFormattedPercent = (decimal, numDecimals = 2) => {
    return `${(decimal * 100).toFixed(numDecimals)}%`;
};

export default getFormattedPercent;
